import {Component, Input, OnInit} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import { Router } from '@angular/router';


@Component({
    selector: 'app-question-redirect-to-url',
    templateUrl: './question-redirect-to-url.component.html',
    styleUrls: ['./question-redirect-to-url.component.scss'],
    standalone: false
})
export class QuestionRedirectToUrlComponent implements OnInit {

  @Input() question: Question;

  constructor(
    public router: Router,
  ) { 
    
  }

  ngOnInit(): void {
    let partner_code = '';
    try{
      partner_code = localStorage.getItem('partner_code');
    } catch{}
    
    let url = this.question.answer;
    if (partner_code !=='' && partner_code) url = url + '&partner_code='+partner_code;
    this.router.navigateByUrl(url);
  }

}
